import { render, staticRenderFns } from "./seriesListItem.vue?vue&type=template&id=4d0ef4ee&scoped=true&"
import script from "./seriesListItem.vue?vue&type=script&lang=js&"
export * from "./seriesListItem.vue?vue&type=script&lang=js&"
import style0 from "./seriesListItem.vue?vue&type=style&index=0&id=4d0ef4ee&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ef4ee",
  null
  
)

export default component.exports